import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ManageUserGroupsWidget from '../../../../widgets/manageUserGroups/ManageUserGroupsWidget'
import { getManageAccess } from '../../../../redux/actions/manageAccess'

export default function ManageUserGroups() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  const mockSchema = {
    header: 'จัดการกลุ่มผู้ใช้งาน',
    // subHeader: 'โครงการ 65-00012-01 : เด็กฉลาด ขอเบิกงวดเงิน',
    subHeader: '',
    form: {
      projectVersionId: '',
      headerInput: [
        {
          label: 'Role',
          type: 'display',
        },
        {
          label: 'ชื่อ',
          type: 'display',
        },
        {
          label: 'สถานะ',
          type: 'select',
        },
        {
          label: 'จัดการสิทธิ์',
          type: 'checkbox',
        },
        {
          label: 'บันทึก/แก้ไขโครงการย่อย',
          type: 'checkbox',
        },
        {
          label: 'อนุมัติโครงการย่อย',
          type: 'checkbox',
        },
        {
          label: 'บันทึก/แก้ไขความก้าวหน้า',
          type: 'checkbox',
        },
        {
          label: 'บันทึก/แก้ไขรายงานการเงิน',
          type: 'checkbox',
        },
        {
          label: 'ตรวสอบรายงาน',
          type: 'checkbox',
        },
        {
          label: 'ตรวสอบรายงาน / ให้ความเห็น',
          type: 'checkbox',
        },
      ],
      input: {
        role: {
          label: 'Role',
          name: 'role',
          type: 'display',
          // value: 'THP-XXXX1',
        },
        name: {
          label: 'ชื่อ',
          name: 'name',
          type: 'display',
          // value: 'หัวหน้าหน่วยจัดการ',
        },
        status: {
          label: 'สถานะ',
          name: 'status',
          type: 'select',
          options: [
            { disabled: false, label: 'Active', value: 1 },
            { disabled: false, label: 'InActive', value: 0 },
          ],
          // value: 'Active',
        },
        userRoleMenu: {
          label: 'จัดการสิทธิ์',
          name: 'userRoleMenu',
          type: 'checkbox',
          options: [{ disabled: false, label: 'Selected', value: true }],
          // value: 0,
        },
        readEditSubproject: {
          label: 'บันทึก/แก้ไขโครงการย่อย',
          name: 'readEditSubproject',
          type: 'checkbox',
          options: [{ disabled: false, label: 'Selected', value: true }],
          // value: 0,
        },
        approveSubproject: {
          label: 'อนุมัติโครงการย่อย',
          name: 'approveSubproject',
          type: 'checkbox',
          options: [{ disabled: false, label: 'Selected', value: true }],
          // value: 0,
        },
        readEditProgress: {
          label: 'บันทึก/แก้ไขความก้าวหน้า',
          name: 'readEditProgress',
          type: 'checkbox',
          options: [{ disabled: false, label: 'Selected', value: true }],
          // value: 0,
        },
        readEditMoneyReport: {
          label: 'บันทึก/แก้ไขรายงานการเงิน',
          name: 'readEditMoneyReport',
          type: 'checkbox',
          options: [{ disabled: false, label: 'Selected', value: true }],
          // value: 0,
        },
        approveReport: {
          label: 'ตรวสอบรายงาน',
          name: 'approveReport',
          type: 'checkbox',
          options: [{ disabled: false, label: 'Selected', value: true }],
          // value: 0,
        },
        checkReportAndAdvise: {
          label: 'ตรวสอบรายงาน / ให้ความเห็น',
          name: 'checkReportAndAdvise',
          type: 'checkbox',
          options: [{ disabled: false, label: 'Selected', value: true }],
          // value: 0,
        },
      },
      values: [
        {
          role: 'THP-XXXX1',
          name: 'หัวหน้าหน่วยจัดการ',
          status: 0,
          userRoleMenu: true,
          readEditSubproject: false,
          approveSubproject: false,
          readEditProgress: false,
          readEditMoneyReport: false,
          approveReport: false,
          checkReportAndAdvise: true,
        },
        {
          role: 'THP-XXXX2',
          name: 'สนับสนุนวิชาการ (พี่เลี้ยง) สนับสนุนวิชาการ (พี่เลี้ยง)',
          status: 1,
          userRoleMenu: true,
          readEditSubproject: false,
          approveSubproject: false,
          readEditProgress: false,
          readEditMoneyReport: false,
          approveReport: false,
          checkReportAndAdvise: false,
        },
        {
          role: 'THP-XXXX3',
          name: 'นักวิชาการ สสส.',
          status: 1,
          userRoleMenu: false,
          readEditSubproject: false,
          approveSubproject: false,
          readEditProgress: false,
          readEditMoneyReport: false,
          approveReport: false,
          checkReportAndAdvise: false,
        },
        {
          role: 'THP-XXXX4',
          name: 'ทีมประเมินผล',
          status: 1,
          userRoleMenu: false,
          readEditSubproject: false,
          approveSubproject: false,
          readEditProgress: false,
          readEditMoneyReport: false,
          approveReport: false,
          checkReportAndAdvise: false,
        },
      ],
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getManageAccess()
      if (response) {
        setSchema(response)
      }

    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isSubProjectReport>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} />

        <ManageUserGroupsWidget schema={schema.form} />
      </SidebarProposal>
    </>
  )
}
